import moment from 'moment';
export default {
    add:{
        date_achat:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            datetime: {
                dateOnly: true,
                latest:moment().format('YYYY-MM-DD'),
                message :"date incorrect"
                // latest: moment.utc().subtract(18, 'years'),
                // message: "^You need to be at least 18 years old"
            }
        },
        fournisseur:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },       
    },
    detail:{
        article:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },   
        unite_stockage:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },   
        quantite:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            numericality:{
                greaterThan:-1,
                message:" doit être superieur à 0"
            },
        },
        prix:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            numericality:{
                greaterThan:0,
                message:" doit être superieur à 0"
            },
        }
    },
    achatMultiple:{
        date_achat:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            datetime: {
                dateOnly: true,
                message :"date incorrect",
                latest:moment().format('YYYY-MM-DD'),
                // latest: moment.utc().subtract(18, 'years'),
                // message: "^You need to be at least 18 years old"
            }
        },
        fournisseur:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },       
        article:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },   
        unite_stockage:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            }
        },   
        quantite:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            numericality:{
                greaterThan:0,
                message:" doit être superieur à 0"
            },
        },
        prix:{
            presence: {
                allowEmpty: false,
                message:"est obligatoire"
            },
            numericality:{
                greaterThan:0,
                message:" doit être superieur à 0"
            },
        }
    }
}